import { Checkbox, Paper, Typography, IconButton } from "@mui/material";
import RouteIcon from '@mui/icons-material/Route';
import ColorInformer from '../ColorInformer';
import useStyles from "./useStyles";

import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

function RouteInfoObj(props) {
  const {
    /**полный объект данных об маршруте (без маршрута) */
    dataObj,
    /**Ф-ция для сохранения объекта */
    updateDataObj,
    deleteItem,
  } = props
  const {
    dataRange,
    name,
    active,
    color,
    points
  } = dataObj;

  const classes = useStyles();


  const handleCheckBoxClick = () => {
    updateDataObj({ ...dataObj, active: !active })
  }

  return (
    <div className={classes.info}>
      {/* <Paper> */}

      <div className={classes.infoWrap}>
        <Checkbox className={classes.checkbox}
          onClick={handleCheckBoxClick}
          checked={active}
        />
        <RouteIcon fontSize='small' />
        <ColorInformer color={color} />
        <div style={{marginLeft:"3px"}}>
          <Typography variant="body2" style={{ marginBottom: "-10px" }}>
            {name}
          </Typography>
          <Typography variant="caption" style={{ fontSize: "65%" }}>
            {dataRange}
          </Typography>
        </div>
        <IconButton
          style={{ padding: "0" }}
          // sx={{ minWidth: "16px" }}
          // id="demo-positioned-button"
          onClick={deleteItem}
        >
          <DeleteForeverIcon />
        </IconButton>
      </div>
      {/* <ButtonWitchMenu id={key_item} name={title}/> */}
      {/* </Paper> */}
    </div>
  )
};

export default RouteInfoObj;
